import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert } from '@mui/material';
import Cookies from 'js-cookie';
import { useLazyQuery } from '@apollo/client';
import { checkHashHeaderSync } from 'src/utils/checkHashHeader';
import { styled } from '@mui/material/styles';
import TagManager from 'react-gtm-module';
import Subscribe from '../components/Subscribe';
import Spinner from '../components/Spinner';
import Page from '../components/Page';
import { GET_USER_STATUS } from '../graphql';
import getErrorCode from '../utils/getErrorCode';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

const Home = () => {
  const navigate = useNavigate();
  const [showError, setShowError] = useState(false);

  // Lazy query: only triggered when explicitly called
  const [getUserStatus, { data, loading, error }] = useLazyQuery(GET_USER_STATUS, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let click_id = urlParams.get('click_id') || '';
    sessionStorage.setItem('click_id', click_id);
    let advertiser_id = urlParams.get('advertiser_id') || 'Solunet';
    sessionStorage.setItem('advertiser_id', advertiser_id);

    const checkUserStatus = async () => {
      try {
        const promise = await checkHashHeaderSync();
        const promiseStr = promise?.toString() || '';
        console.log(promiseStr)

        if (promiseStr.includes('Error') || promiseStr.includes('MSISDN request failed')) {
          // cleanup
          Cookies.remove('msisdn');
          Cookies.remove('msisdnHash');
          localStorage.removeItem('msisdn');
          localStorage.removeItem('msisdnHash');
          setTimeout(() => {
            navigate('/he-disable');
          }, 2000);
          return;
        }

        // Save msisdn
        localStorage.setItem('msisdn', promiseStr);
        localStorage.setItem('msisdnHash', promiseStr);
        Cookies.set('msisdn', promiseStr);

        // ✅ Trigger GraphQL query only after hash check passes
        getUserStatus();
      } catch (err) {
        console.error('Error:', err);
        navigate('/he-disable');
      }
    };

    checkUserStatus();
  }, [navigate, getUserStatus]);

  useEffect(() => {
    if (data && data.getUserStatus) {
      const { msisdn, responseCode } = data.getUserStatus;

      switch (responseCode) {
        case 200:
          localStorage.setItem('subscribed', 'true');
          TagManager.dataLayer({
            dataLayer: {
              event: 'userSubscribed',
              userId: msisdn,
            },
          });
          setTimeout(() => {
            navigate('/app/games');
          }, 1000);
          break;

        case 100:
        case 400:
        case 600:
        case 700:
        case 800:
          localStorage.setItem('subscribed', '');
          navigate('/subscribe?m=unable');
          break;

        case 500:
          localStorage.setItem('subscribed', '');
          navigate('/not-subscribe');
          break;

        default:
          Cookies.set('msisdn', '');
          localStorage.setItem('msisdn', '');
          navigate('/auth');
          break;
      }
    } else if (error) {
      setTimeout(() => setShowError(true), 4000);
    }
  }, [data, error, navigate]);

  return (
    <Page title="Home | Zetuplay">
      <Container maxWidth="xl">
        <ContentStyle>
          {loading && (
            <>
              <Spinner />
              <Alert severity="info">Just a second, adventure mode awaits....</Alert>
            </>
          )}

          {!loading && error && showError && (
            <>
              {error.graphQLErrors && getErrorCode(error) === 404 ? (
                <Subscribe code={getErrorCode(error)} />
              ) : (
                <Alert severity="error">Opps! Glitch alert—refresh to game on!.</Alert>
              )}
            </>
          )}
        </ContentStyle>
      </Container>
    </Page>
  );
};

export default Home;
